import "./stylesheets/sass/styles.scss";
import "./js/search";
import "./js/nav.js";
import "./js/alerts.js";
import "./js/quiz";
import "./js/helper";
import "./js/gallery";
import "./js/anchor-scroll";
import "./js/spotlight";
import "./js/explore-programs-animation.ts";
import "./js/stats-list.ts";
import "./js/image-fade-in.ts";
import "./js/tables";
